import { apiHelper } from '../utils/apiHelper';

// const API_URL = `${getApiBaseUrl()}/api/admin/child-categories`;
const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/child-categories`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchChildCategories = (payload) => apiHelper(API_URL, 'POST', payload, headers);